module.exports = __webpack_public_path__ + "b93a8cf492542a4ea5f8fa87615cf952.svg"